<template>
  <!-- SECTION-CONTATO -->
  <div id="section-partners" class="col-12 p-0">
    <div class="container">
      <router-link v-if="!screen" to="/" class="fa fa-2x fa-times d-lg-flex"></router-link>
      <div class="row m-0">
        <div class="col-10 offset-2 col-lg-8 px-0 d-flex flex-column justify-content-end my-3">
          <h4>Contato</h4>
          <p>Entre em contato, teremos prazer em conversar com você, basta preencher o formulário abaixo e enviar.</p>
        </div>
      </div>
    </div>
    <div class="container ">
      <div class="row h-100 bg-white mx-0 mb-5 box-email rounded">
        <div class="d-none d-md-flex col-md-4 p-0">
          <img class="h-100 rounded-left" src="@/assets/login/formulario.png" alt="Formulario"
            style="object-fit:cover;object-position:center;">
        </div>
        <div class="col rounded-right">
          <div class="row my-3 mx-auto h-100 justify-content-center align-content-around">
            <div class="col-10 px-0 px-md-3 py-4 text-center">
              <p class="text-center">Informe o assunto de interesse: </p>
              <div class="row btn-group btn-group-toggle w-100 mx-0" data-toggle="buttons">
                <label v-for="(topic,i) in assuntos" :key="i"
                  class="btn btn-sm btn-outline-info font-weight-normal justify-content-center d-flex align-items-center"
                  :class="{'active':(request.type==topic)}">
                  <input @click="request.type=topic" :checked="(request.type==topic)" type="radio" name="options" id="option1" autocomplete="off">
                  {{ topic }}
                </label>
              </div>
            </div>
            <!-- <div class="row my-3 mx-auto justify-content-center"> -->
            <div class="col-10 px-0 px-md-3">
              <div class="mb-3 w-100 position-relative" :class="{'is-invalid': errors.has('Nome')}">
                <span class="fa fa-user p-1 text-gray position-absolute"></span>
                <input v-validate="{required: true}" v-model="request.name" name="Nome" type="text" placeholder="Nome"
                  class="pl-4" />
              </div>
              <div class="mb-3 w-100 position-relative" :class="{'is-invalid': errors.has('Telefone')}">
                <span class="fa fa-phone p-1 text-gray position-absolute"></span>
                <input v-mask="['(##)# ####-####','(##) ####-####']" name="Telefone" v-validate="{required: true}"
                  v-model="request.phone" type="text" placeholder="Telefone" class="pl-4" />
              </div>
              <div class="mb-3 w-100 position-relative" :class="{'is-invalid': errors.has('Email')}">
                <span class="fa fa-address-card p-1 text-gray position-absolute"></span>
                <input v-validate="{required: true}" v-model="request.email" name="Email" type="email"
                  placeholder="E-mail" class="pl-4" />
              </div>
              <div class="mb-3 w-100 position-relative" :class="{'is-invalid': errors.has('Mensagem')}">
                <span class="fa fa-commenting-o p-1 text-gray position-absolute"></span>
                <textarea v-model="request.message" name="Mensagem" v-validate="{required: true}"
                  style="min-height:100px;max-height:100px;" placeholder="Mensagem..." rows="3"
                  class="w-100 pl-4"> </textarea>
              </div>
              <div class="mb-3 w-100 form-check">
                <input v-model="request.auth" type="checkbox" id="checkTermos" class="form-check-input" name="Check" />
                <label for="checkTermos" class="form-check-label">Concordo com o
                  <a data-toggle="modal" data-target="#ChangeTermos"><u class="text-primary"
                      style="cursor:pointer;">Termo</u></a> e com o recebimento de emails
                  da AR MBD, proprietária da plataforma DocXDigital.</label>
              </div>
            </div>
            <!-- </div> -->
            <div class="col-10 py-4 text-center">
              <button @click="mountMail()" :disabled="loading" id="btnConfirm" class="btn btn-success px-3">
                <i class="fa fa-send"></i> Enviar
                <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-termos />
  </div>
</template>

<script>
  import axios from 'axios';
  import mTermos from '../../auth/components/m-change-termos.vue';
  export default {
    props: ['screen'],
    components: {
      mTermos,
    },
    data() {
      return {
        loading: false,
        request: {
          type: 'Interessado em demonstração',
          name: null,
          phone: null,
          email: null,
          message: null,
          auth: true,
          grecaptcha: null,
        },
        assuntos: [
          'Interessado em demonstração',
          'Suporte da plataforma',
          'Tornar-se revenda/parceiro',
          'Outros',
        ]
      }
    },
    methods: {
      async mountMail() {
        this.loading = true;
        this.request.grecaptcha = await this.$recaptcha("contato").then(token => {
          return token;
        });
        this.$validator.validateAll().then(valid => {
          if (valid) this.sendEmail();
          else toastr({
            title: 'Preencha os campos!!',
            icon: 'error', // error, warning, info, success
            position: 'top-right',
            showConfirmButton: false,
            showCancelButton: false,
            html: null,
            timer: 5000
          })
        }).finally(() => {
          this.loading = false;
        })
      },
      sendEmail() {
        this.loading = true;
        axios.post('/api/email-contato', this.request).then(response => {
          toastr({
            title: response.data.message,
            icon: response.data.status,
            position: 'top-right',
            showConfirmButton: false,
            showCancelButton: false,
            html: null,
            timer: 5000
          });
          this.request = {
            type: 'Interessado em demonstração',
            name: null,
            phone: null,
            email: null,
            message: null,
            auth: true,
            grecaptcha: null,
          }
        }).catch(error => {
          return error.response.data;
        }).finally(() => {
          this.loading = false;
          this.$validator.reset();
        })
      },
    }
  }
</script>


<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
  a.fa-times {
    color: #ff4d4d;
    text-decoration: none;
    cursor: pointer;
    position: fixed;
    top: 3vw;
    left: 1.5vw;
    z-index: 20;
  }

  [id*='section-'] {
    background-color: #f8f9fa !important;
    font-family: 'Montserrat';
    min-height: 100vh;
    /* z-index: 10; */
  }

  h4 {
    font-size: 32px;
    line-height: 1.1875;
    font-family: "Montserrat";
  }

  p {
    font-size: medium;
    line-height: 1.5;
  }

  .btn-outline-info {
    max-width: 150px;
  }

  .box-email {
    width: 100%;
    /* border-radius: 5px; */
    box-shadow: 1px 1px 10px 3px dimgray;
  }

  input:not([type='checkbox']) {
    width: 100%;
    border: 0;
    background-color: transparent;
    border-bottom: 1px solid dimgray;
  }

  input:focus,
  textarea:focus {
    outline-width: 0;
  }

  .is-invalid .fa,
  .is-invalid input::placeholder,
  .is-invalid textarea::placeholder {
    color: #dc3545 !important;
  }

  .is-invalid input {
    border-bottom: 1px solid #dc3545;
  }

  .is-invalid textarea {
    border-color: #dc3545;
  }

  .btn:not(.btn-outline-info):hover {
    color: #fff;
    transform: scale(1.2);
    transition: all 0.3s;
  }

  @media screen and (min-width: 992px) {
    .h-lg-100 {
      height: 100%;
    }
  }

  @media screen and (max-width: 992px) {
    h4 {
      font-size: 22px;
    }
  }
</style>